import React from "react";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { History, BarChart, Handshake } from "@mui/icons-material";
import { IProps } from "./IProps";

export const FloatingActionButtonMenu: React.FC<IProps> = (props) => {
  const options = [
    {
      title: "View Changes",
      icon: <History />,
      onClick: () => null,
    },
    {
      title: "View UTM Data",
      icon: <BarChart />,
      onClick: () => null,
    },
    {
      title: "View Trusted Form Data",
      icon: <Handshake />,
      onClick: () => null,
    },
  ];

  return (
    <SpeedDial
      ariaLabel="FAB with Menu"
      sx={{ position: "fixed", bottom: 16, right: 16 }}
      icon={<SpeedDialIcon openIcon={<MoreVertIcon />} />}
    >
      {props.options.map((option, index) => {
        return (
          <SpeedDialAction
            sx={{ color: "#1BA0E9" }}
            icon={option.icon}
            tooltipTitle={option.title}
            onClick={option.onClick}
          />
        );
      })}
    </SpeedDial>
  );
};
